import React, { useState } from 'react';
import './ModeEmploi.scss';

const ModeEmploi = ({ isOpen, onClose }) => {
    const [activeTab, setActiveTab] = useState('creer'); // 'creer' ou 'rejoindre'
    const [dontShowAgain, setDontShowAgain] = useState(false);

    if (!isOpen) return null;

    const handleClose = () => {
        if (dontShowAgain) {
            localStorage.setItem('memozyn_hide_mode_emploi', 'true');
        }
        onClose();
    };

    return (
        <div className="modal-overlay mode-emploi-overlay" onClick={handleClose}>
            <div 
                className="modal-content mode-emploi-modal" 
                onClick={(e) => e.stopPropagation()}
            >
                {/* Bouton de fermeture en haut à droite */}
                <button className="btn-close-modal" onClick={handleClose} aria-label="Fermer">
                    ✕
                </button>

                {/* En-tête de la modale */}
                <div className="mode-emploi-header">
                    <span className="mode-emploi-badge-top">GUIDE DE DÉMARRAGE</span>
                    <h2>Mode d'Emploi de Mémozyn</h2>
                    <p className="mode-emploi-subtitle">
                        Suivez ces quelques étapes simples pour lancer ou rejoindre une partie en quelques secondes !
                    </p>
                </div>

                {/* Onglets de navigation */}
                <div className="mode-emploi-tabs">
                    <button 
                        className={`tab-btn ${activeTab === 'creer' ? 'active' : ''}`}
                        onClick={() => setActiveTab('creer')}
                    >
                        <span className="tab-icon">🚀</span>
                        <span className="tab-text">1. Créer une partie</span>
                    </button>
                    <button 
                        className={`tab-btn ${activeTab === 'rejoindre' ? 'active' : ''}`}
                        onClick={() => setActiveTab('rejoindre')}
                    >
                        <span className="tab-icon">📱</span>
                        <span className="tab-text">2. Rejoindre une partie</span>
                    </button>
                </div>

                {/* Contenu de l'onglet actif */}
                <div className="mode-emploi-body">
                    {activeTab === 'creer' ? (
                        <div className="guide-section fade-in">
                            <div className="section-intro">
                                <span className="role-tag host-role">Rôle : Joueur Hôte (Créateur)</span>
                                <h3>Comment créer et lancer une partie ?</h3>
                            </div>

                            <div className="steps-container">
                                {/* Étape 1 */}
                                <div className="step-card">
                                    <div className="step-badge step-1">1</div>
                                    <div className="step-content">
                                        <h4>Choisir votre pseudo</h4>
                                        <p>Dans la boîte <strong>« Créer une partie »</strong>, tapez votre pseudo ou prénom pour vous identifier.</p>
                                        <div className="visual-mockup">
                                            <div className="mockup-label">Votre pseudo :</div>
                                            <div className="mockup-input">
                                                <span>Alice</span>
                                                <span className="mockup-cursor">|</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Étape 2 */}
                                <div className="step-card">
                                    <div className="step-badge step-2">2</div>
                                    <div className="step-content">
                                        <h4>Choisir le nombre de tours</h4>
                                        <p>Sélectionnez la durée de la partie (5, 10, 15 ou 20 tours).</p>
                                        <div className="visual-mockup">
                                            <div className="mockup-label">Nombre de tours :</div>
                                            <div className="mockup-select">
                                                <span>10 tours (Standard)</span>
                                                <span className="mockup-arrow">▾</span>
                                            </div>
                                        </div>
                                        <div className="alert-box-warning">
                                            <span className="alert-icon">⚠️</span>
                                            <span><strong>Attention :</strong> Le nombre de tours ne pourra plus être modifié une fois la partie lancée !</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Étape 3 */}
                                <div className="step-card">
                                    <div className="step-badge step-3">3</div>
                                    <div className="step-content">
                                        <h4>Cliquer sur « Créer une partie »</h4>
                                        <p>Validez pour ouvrir la salle d'attente et obtenir le <strong>Code de la partie</strong> à partager avec vos amis.</p>
                                        <div className="visual-mockup btn-mockup-wrapper">
                                            <div className="mockup-btn btn-creer-style">
                                                Créer une partie 🚀
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="guide-section fade-in">
                            <div className="section-intro">
                                <span className="role-tag guest-role">Rôle : Joueur Invité</span>
                                <h3>Comment rejoindre une partie en cours ?</h3>
                            </div>

                            <div className="steps-container">
                                {/* Étape 1 */}
                                <div className="step-card">
                                    <div className="step-badge step-1">1</div>
                                    <div className="step-content">
                                        <h4>Cliquer sur « S'inscrire » dans la liste</h4>
                                        <p>Repérez la partie créée par votre ami dans la liste <strong>« Parties en cours »</strong> et cliquez sur le bouton vert <strong>« S'inscrire »</strong>.</p>
                                        <div className="visual-mockup">
                                            <div className="mockup-room-item">
                                                <div className="mockup-room-info">
                                                    <span className="mockup-dot-live"></span>
                                                    <span>Partie en cours : <strong>Alice</strong> (10 tours)</span>
                                                </div>
                                                <div className="mockup-btn-fluo">
                                                    S'inscrire 👈
                                                </div>
                                            </div>
                                        </div>
                                        <div className="tip-box">
                                            💡 <em>Le champ « Code de la partie » sera alors rempli automatiquement !</em>
                                        </div>
                                    </div>
                                </div>

                                {/* Étape 2 */}
                                <div className="step-card">
                                    <div className="step-badge step-2">2</div>
                                    <div className="step-content">
                                        <h4>Choisir votre pseudo</h4>
                                        <p>Renseignez votre propre pseudo dans le champ <strong>« Votre pseudo »</strong>.</p>
                                        <div className="visual-mockup">
                                            <div className="mockup-label">Votre pseudo :</div>
                                            <div className="mockup-input">
                                                <span>Bob</span>
                                                <span className="mockup-cursor">|</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Étape 3 */}
                                <div className="step-card">
                                    <div className="step-badge step-3">3</div>
                                    <div className="step-content">
                                        <h4>Cliquer sur « Rejoindre la partie »</h4>
                                        <p>Cliquez sur le bouton bleu pour entrer dans la salle d'attente. Vous attendrez ensuite que le joueur hôte lance la partie.</p>
                                        <div className="visual-mockup btn-mockup-wrapper">
                                            <div className="mockup-btn btn-rejoindre-style">
                                                Rejoindre la partie 📱
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* Pied de la modale */}
                <div className="mode-emploi-footer">
                    <div className="footer-left">
                        <label className="checkbox-container">
                            <input 
                                type="checkbox" 
                                checked={dontShowAgain} 
                                onChange={(e) => setDontShowAgain(e.target.checked)} 
                            />
                            <span className="checkmark"></span>
                            <span className="checkbox-text">Ne plus afficher automatiquement</span>
                        </label>
                    </div>

                    <div className="footer-right">
                        {activeTab === 'creer' ? (
                            <button 
                                className="btn-footer-nav" 
                                onClick={() => setActiveTab('rejoindre')}
                            >
                                Voir comment rejoindre 📱 ➔
                            </button>
                        ) : (
                            <button 
                                className="btn-footer-nav" 
                                onClick={() => setActiveTab('creer')}
                            >
                                ⬅ Voir comment créer 🚀
                            </button>
                        )}
                        <button className="btn-footer-action" onClick={handleClose}>
                            C'est parti ! 🎮
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModeEmploi;
